// homepage.js
import initSliderHome from '../components/slider-home';
import initGenericSliders from '../components/slider-generico';
import initSliderTopics from '../components/slider-topics';


export default function initHomepage() {
    // Initialize the Slider component
    const sliderElement = document.querySelector('#sliderHero');
    const sliderContainer = document.querySelector('.slider-generic');
    const sliderTopicsContainer = document.querySelector('#posts-slider');

    if (sliderElement) {
        const props = JSON.parse(sliderElement.getAttribute('data-props'));
        initSliderHome(sliderElement, props);
    }

    if (sliderTopicsContainer) {
        initSliderTopics();
    }

    if (sliderContainer) {
        initGenericSliders();
    }

}